<template>
    <div class="page view">
        <h1>2.1REST APIs</h1>

    </div>
</template>